import React from 'react';
import { observer } from 'mobx-react';
import { reverse } from 'named-urls';
import { Link } from 'react-router-dom';

import EventItem from 'ui/Feed/EventItem';

import routes from 'core/routes';

import { UuidableName } from 'utils/api/types';
import { EventItemProps } from 'ui/Feed/EventItem/types';

import { TaskName } from './styles';

type TaskLinkActivityProps = Omit<EventItemProps, 'children'> & {
  activity: EventItemProps['activity'] & { task?: UuidableName };
};

const TaskLinkActivity = ({ activity, sessionUser }: TaskLinkActivityProps): React.ReactElement => (
  <EventItem activity={activity} sessionUser={sessionUser}>
    raised action{' '}
    {activity.task && (
      <TaskName to={reverse(routes.dashboard.tasks.details, { taskId: activity.task.uuid })} as={Link}>
        {activity.task.name}
      </TaskName>
    )}
  </EventItem>
);

export default observer(TaskLinkActivity);
